import React from 'react';
import SignaturePreview from './SignaturePreview';
import './VersionPreviewModal.css';

function VersionPreviewModal({ isOpen, version, onClose }) {
    if (!isOpen || !version) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="version-preview-modal-overlay" onClick={handleOverlayClick}>
            <div className="version-preview-modal-content">
                <div className="version-preview-modal-header">
                    <div>
                        <h2>Aperçu de la version {version.version_number}</h2>
                        <p className="version-preview-modal-subtitle">
                            {version.name} - {new Date(version.created_at).toLocaleString('fr-FR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </p>
                    </div>
                    <button className="version-preview-modal-close" onClick={onClose}>
                        <svg
                            width="24"
                            height="24"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                <div className="version-preview-modal-body">
                    <SignaturePreview
                        gridData={version.grid_data}
                        containerWidth={version.container_width || 600}
                        scale={1}
                    />
                </div>

                <div className="version-preview-modal-footer">
                    <button className="version-preview-close-btn" onClick={onClose}>
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
}

export default VersionPreviewModal;
